import type { PublicProduct } from '../graphql/public'
import { activeVariants } from '../lib/catalog'
import { Markers } from './Markers'
import { Price } from './Price'
import { PromoChip } from './PromoChip'
import { SoldOutBand } from './SoldOutBand'

// The two-line row of the main list: name + promo chip on the first line, the marker
// line under it, prices right in one 170 px column per variant. Rows carry name and
// markers only — a description at this size is unreadable from the queue (lessons.md).
export function ProductRow({ product }: { product: PublicProduct }) {
  const variants = activeVariants(product)
  return (
    <div
      className={
        'flex items-center space-x-[24px] py-[10px] border-b-2 border-brand-line' +
        (product.sold_out ? ' opacity-60' : '')
      }
    >
      <div className="flex-1 flex flex-col space-y-[4px] min-w-0">
        <div className="flex items-center space-x-[16px]">
          <div className="font-primary font-bold text-[40px] leading-[1.05] text-secondary-800 whitespace-nowrap overflow-hidden text-ellipsis">
            {product.name}
          </div>
          {product.sold_out ? <SoldOutBand size={24} /> : <PromoChip product={product} size={24} />}
        </div>
        <div className="flex items-center min-h-[36px]">
          <Markers product={product} size={30} />
        </div>
      </div>
      {variants.map((v) => (
        <div key={v.id} className="w-[170px] text-right">
          <Price cents={v.price_cents} size={40} />
        </div>
      ))}
    </div>
  )
}
